import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { AiPromoIllustration } from "./illustration/AiPromoIllustration";

const Container = styled(Flex)`
    width: 100%;
    height: 100%;
    justify-content: center;
    overflow: auto;
`;

const InnerContainer = styled(Stack)`
    align-items: center;
    gap: 24px;
    padding: 80px 0;
`;

const TextBlock = styled(Stack)`
    align-items: center;
    text-align: center;
    gap: 8px;
    max-width: 520px;
`;

export const AiChannelsPromoPage = () => {
    const { translate } = useTranslate();
    return (
        <Container data-automation="ai-channels-promo">
            <InnerContainer>
                <TextBlock>
                    <Text
                        fontVariant="h2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("ad.intelligence.llms.channels.promo.title")}
                    </Text>
                    <Text
                        fontVariant="h5"
                        color={colorsPalettes.carbon[400]}
                    >
                        {translate("ad.intelligence.llms.channels.promo.subtitle")}
                    </Text>
                </TextBlock>
                <AiPromoIllustration />
            </InnerContainer>
        </Container>
    );
};
